import { useEffect, useRef } from "react"
import logo from "./resources/logo.png";

const DownloadRedirect: React.FC = () => {
    const appName = process.env.REACT_APP_NAME;
    const appPath = process.env.REACT_APP_PATH;
    const appPackage = process.env.REACT_APP_PACKAGE;
    const websiteUrl = process.env.WEBSITE_URL
    let fallback = "https://apps.apple.com/app/id6754385939?mt=8";
    const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);


    useEffect(() => {
        const cancelFallback = () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };

        document.addEventListener("visibilitychange", cancelFallback);
        if (/Android/i.test(window.navigator.userAgent)) {
            let intentURL = `intent://Download#Intent;scheme=${appName};package=${appPackage};action=android.intent.action.VIEW;category=android.intent.category.DEFAULT;category=android.intent.category.BROWSABLE;`;
            fallback = "https://play.google.com/store/apps/details?id=com.dropprofessional.Drop";
            intentURL += `S.browser_fallback_url=${encodeURIComponent(
                fallback
            )}`;
            intentURL += `;end`;
            window.location.href = intentURL;
            timeoutRef.current = setTimeout(() => {
                window.location.href = fallback;
            }, 3000);
            return;
        } else if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
            const deepLink = `${appName}://${appPath}/download`;

            window.location.href = deepLink;
            timeoutRef.current = setTimeout(() => {

                window.location.href = fallback;

            }, 3000);
            return;
        }
        window.location.href = websiteUrl || "https://dropprofessionals.com"

        return () => {
            document.removeEventListener("visibilitychange", cancelFallback);

            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <main className="main-content">
            <img src={logo} alt="logo" height="100%" width="100%" />
        </main>
    )
}

export default DownloadRedirect;